import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const AtlassianAPITokenDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.display_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.display_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.atlassian_api_token_data?.status && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Status
            </Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.atlassian_api_token_data?.status}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.connected_email && (
        <RelatedUserSection
          entityData={entityData}
          contextName="atlassian api token - nhi details view"
        />
      )}
      {!entityData?.connected_email &&
        entityData?.atlassian_api_token_data?.user !== undefined && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>User</Typography>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
              <TextIntegrationStyle
                title={"name"}
                value={entityData?.atlassian_api_token_data?.user?.name}
              ></TextIntegrationStyle>

              <TextIntegrationStyle
                title={"email"}
                value={entityData?.atlassian_api_token_data?.user?.email}
              ></TextIntegrationStyle>
            </Box>
          </Box>
        )}
    </Box>
  );
};

export default AtlassianAPITokenDetailsView;
